// src/components/bsm/SyllabusModal.js
import React, { useEffect } from 'react';
import { DocIcon, CloseIcon, WhatsAppIcon } from './BsmIcons';

export default function SyllabusModal({ courseTitle, onClose, onEnroll }) {
  useEffect(() => {
    if (!courseTitle) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [courseTitle, onClose]);

  if (!courseTitle) return null;

  return (
    <div className="modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="syllabus-modal-title">
      <div className="modal-content-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title-with-icon">
              <DocIcon width={20} height={20} className="modal-title-ico" />
              <h3 id="syllabus-modal-title">Course Curriculum: {courseTitle}</h3>
            </div>
            <p>Official NISM-aligned curriculum breakdown • Brilliant Share Market Academy</p>
          </div>
          <button
            type="button"
            className="btn-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <CloseIcon width={16} height={16} />
          </button>
        </div>

        <div className="modal-body">
          <div className="syllabus-preview-box">
            <h4>Course Blueprint &amp; Learning Outcomes</h4>
            <ul>
              <li><strong>Module 1:</strong> Market Architecture, Clearing Corporations, Order Routing &amp; Demat Operations.</li>
              <li><strong>Module 2:</strong> Advanced Price Action, Multi-Timeframe Candlestick Formations, Support &amp; Demand Zones.</li>
              <li><strong>Module 3:</strong> Quantitative Risk Frameworks, Position Sizing Formulas, Invalidation Levels.</li>
              <li><strong>Module 4:</strong> Live Market Hours Execution Lab (NSE/BSE 9:15 AM - 3:30 PM) with Mentor Oversight.</li>
              <li><strong>Module 5:</strong> Trading Psychology, Discipline Maintenance, Drawdown Management &amp; Trade Journaling.</li>
            </ul>
          </div>

          <div className="syllabus-download-action">
            <button
              type="button"
              className="btn-modal-whatsapp"
              onClick={() => onEnroll(courseTitle)}
            >
              <WhatsAppIcon width={16} height={16} />
              <span>Get Full PDF Syllabus &amp; Fee Sheet on WhatsApp</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
